export enum ElementPropertyRulesRequestTypes {
  SetElementPropertyRuleRequest = 'elementpropertyrules.set.request',
  SetElementPropertyRuleSuccess = 'elementpropertyrules.set.success',
  SetElementPropertyRuleFailure = 'elementpropertyrules.set.failure',
  GetAllElementPropertyRulesRequest = 'elementpropertyrules.getall.request',
  GetAllElementPropertyRulesSuccess = 'elementpropertyrules.getall.success',
  GetAllElementPropertyRulesFailure = 'elementpropertyrules.getall.failure',
  ArchiveElementPropertyRuleRequest = 'elementpropertyrules.archive.request',
  ArchiveElementPropertyRuleSuccess = 'elementpropertyrules.archive.success',
  ArchiveElementPropertyRuleFailure = 'elementpropertyrules.archive.failure',
  ArchiveMultiElementPropertyRuleRequest = 'elementpropertyrules.archivemulti.request',
  ArchiveMultiElementPropertyRuleSuccess = 'elementpropertyrules.archivemulti.success',
  ArchiveMultiElementPropertyRuleFailure = 'elementpropertyrules.archivemulti.failure',
  UnarchiveElementPropertyRuleRequest = 'elementpropertyrules.unarchive.request',
  UnarchiveElementPropertyRuleSuccess = 'elementpropertyrules.unarchive.success',
  UnarchiveElementPropertyRuleFailure = 'elementpropertyrules.unarchive.failure',
  UnarchiveMultiElementPropertyRuleRequest = 'elementpropertyrules.unarchivemulti.request',
  UnarchiveMultiElementPropertyRuleSuccess = 'elementpropertyrules.unarchivemulti.success',
  UnarchiveMultiElementPropertyRuleFailure = 'elementpropertyrules.unarchivemulti.failure',
}
